"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _userContext = require("../../server-middleware/userContext");

var _Dropdown = _interopRequireDefault(require("../User/Dropdown"));

var _classnames = _interopRequireDefault(require("classnames"));

var _slider = _interopRequireDefault(require("../slider"));

var _Menu = _interopRequireDefault(require("@insided/destination/icons/Menu"));

var _AiStarsV = _interopRequireDefault(require("@insided/destination/icons/AiStarsV2"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _MegaMenuLink = _interopRequireDefault(require("./MegaMenuLink"));

var _megaMenuSearch = _interopRequireDefault(require("./megaMenuSearch"));

var _Search = _interopRequireDefault(require("../algolia/components/Search"));

var _SearchWidget = require("@insided/destination/modules/Search/Features/SearchWidget");

var _AddTopicAnchor = _interopRequireDefault(require("./AddTopicAnchor"));

var _LoginAnchor = _interopRequireDefault(require("./LoginAnchor"));

var _CommunityLanguageSwitcher = _interopRequireDefault(require("@insided/shared/modules/MultiLanguage/CommunityLanguageSwitcher"));

var _common = require("@insided/shared/utils/common");

var _NotificationCenter = _interopRequireDefault(require("./notification-center/NotificationCenter"));

var _Logo = require("./Logo");

var _utils = require("./utils");

var _ModuleEnablementContext = require("@insided/shared/services/ModuleEnablementContext");

var _schema = require("./schema");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'mega_menu';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-mega_menu';
exports.cssAnchorName = cssAnchorName;

function isTopicNew() {
  if (typeof window === 'undefined') return null;
  return window.location.pathname.match(/^\/topic\/new/);
}

var ALLOWED_ROLES = ['roles.super-admin', 'roles.community-manager', 'roles.moderator', 'roles.administrator', 'Gainsight Employee'];

var HeaderNavigation = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HeaderNavigation, _Component);

  var _super = _createSuper(HeaderNavigation);

  function HeaderNavigation() {
    var _this;

    (0, _classCallCheck2.default)(this, HeaderNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      extendSearch: false,
      enableFocusToSearch: false,
      isMenuOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleMenu", function (isOpen) {
      var bodyWrapper = window.document.body;

      _this.setState({
        isMenuOpen: isOpen
      });

      if (isOpen) {
        bodyWrapper.classList.add('body-overlay');
      } else {
        bodyWrapper.classList.remove('body-overlay');
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "callbackOutsideClickHandler", function () {
      return _this.setState({
        extendSearch: false,
        enableFocusToSearch: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(HeaderNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Validate categories data from backend on mount using safeParse
      var communityResult = _schema.MegaMenuCategoriesSchema.safeParse(this.props.communityCategoriesV2);

      var knowledgeBaseResult = _schema.MegaMenuCategoriesSchema.safeParse(this.props.knowledgeBaseCategoriesV2);

      var phrasesResult = _schema.MegaMenuPhrasesSchema.safeParse(this.props.phrases); // Log validation errors


      if (!communityResult.success) {
        console.error('[MegaMenu] Invalid community categories:', communityResult.error);
      }

      if (!knowledgeBaseResult.success) {
        console.error('[MegaMenu] Invalid knowledgeBase categories:', knowledgeBaseResult.error);
      }

      if (!phrasesResult.success) {
        console.error('[MegaMenu] Invalid phrases structure:', phrasesResult.error);
      }
    }
  }, {
    key: "computedItems",
    get: function get() {
      var _this2 = this;

      // Items are already filtered in the template (megaMenu/index.twig) based on productSharedVisibility
      // No need to filter again here - just apply visibility and permission filters
      var allItems = (0, _utils.resolveCustomItems)(this.props.items);

      if (this.props.isSpacesOnly) {
        return allItems.filter(function (item) {
          return item.key === 'spaces';
        });
      }

      var isMegaMenuV2Enabled = _common.common.isModuleActive('megaMenuV2'); // Skip visibility filter only when megaMenuV2 is enabled AND productSharedVisibility is configured
      // (visibility is controlled by productSharedVisibility instead of the simple visibility boolean)


      var skipVisibilityFilter = isMegaMenuV2Enabled && this.props.hasProductSharedVisibility;
      var visibilityFiltered = skipVisibilityFilter ? allItems : allItems.filter(function (item) {
        return item.visibility;
      });
      return visibilityFiltered.filter(function (item) {
        return (0, _utils.hasPermissions)(item.key, _this2.props.permissions);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          ssoLoginUrl = _this$props.ssoLoginUrl,
          communityCustomerTitle = _this$props.communityCustomerTitle,
          logo = _this$props.logo,
          searchInfo = _this$props.searchInfo,
          knowledgeBaseCategoriesV2 = _this$props.knowledgeBaseCategoriesV2,
          communityCategoriesV2 = _this$props.communityCategoriesV2,
          newTopicURL = _this$props.newTopicURL,
          selectedLanguage = _this$props.selectedLanguage,
          enabledLanguages = _this$props.enabledLanguages,
          publishedLanguages = _this$props.publishedLanguages,
          searchRevamp = _this$props.searchRevamp,
          aiSearchSummary = _this$props.aiSearchSummary,
          isGuest = _this$props.isGuest,
          aiSmartSearchEnableForAllRoles = _this$props.aiSmartSearchEnableForAllRoles,
          showAuthPage = _this$props.showAuthPage,
          isEntityEnabled = _this$props.isEntityEnabled;
      var _this$state = this.state,
          extendSearch = _this$state.extendSearch,
          enableFocusToSearch = _this$state.enableFocusToSearch;
      var isExtendableSearchVisible = (0, _utils.shouldShowSearch)();

      var isContentInPreferredLanguageEnabled = _common.common.isModuleActive('contentInPreferredLanguage');

      var languagesList = isContentInPreferredLanguageEnabled ? publishedLanguages !== null && publishedLanguages !== void 0 ? publishedLanguages : [] : enabledLanguages !== null && enabledLanguages !== void 0 ? enabledLanguages : [];
      var hasEnabledLanguages = enabledLanguages && enabledLanguages.length >= 1;
      var hasPublishedLanguages = publishedLanguages && publishedLanguages.length > 1;
      var showLanguageSelector = isContentInPreferredLanguageEnabled ? hasEnabledLanguages || hasPublishedLanguages : hasEnabledLanguages;
      return (0, _preact.h)(_userContext.CurrentUserContext.Consumer, null, function (user) {
        var _user$role$split;

        var userRoles = (_user$role$split = user === null || user === void 0 ? void 0 : user.role.split(',')) !== null && _user$role$split !== void 0 ? _user$role$split : [];
        var filteredItems = (0, _utils.filterItemsByRoles)(_this3.computedItems, userRoles);
        return (0, _preact.h)("section", {
          className: "main-navigation--wrapper header-navigation"
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)("main-navigation-sitewidth", {
            'main-navigation-sitewidth-max-content': _this3.props.selectedTemplate === 1
          })
        }, (0, _preact.h)(_Logo.Logo, {
          src: (0, _absoluteUrlRuntime.resolveUrl)(logo),
          communityCustomerTitle: communityCustomerTitle
        }), (0, _preact.h)("div", {
          className: "header-navigation-items-wrapper"
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('header-navigation-items_and_search', {
            'search-extended': extendSearch
          })
        }, (0, _preact.h)("div", {
          className: "header-navigation-items_and_search-inner"
        }, (0, _preact.h)("nav", {
          role: "navigation"
        }, (0, _preact.h)("ul", {
          className: (0, _classnames.default)('header-navigation-items_menu', {
            'with-extendable-search': isExtendableSearchVisible
          })
        }, filteredItems.map(function (item) {
          return (0, _preact.h)(_MegaMenuLink.default, {
            key: (0, _utils.getUniqueKey)(item),
            item: item,
            parentProps: {
              communityCategoriesV2: communityCategoriesV2,
              knowledgeBaseCategoriesV2: knowledgeBaseCategoriesV2,
              openOnHover: true
            }
          });
        }))), (0, _preact.h)("div", {
          className: "header-navigation-items_hamburger"
        }, (0, _preact.h)(_slider.default, {
          title: "Menu",
          open: _this3.state.isMenuOpen,
          onToggle: _this3.toggleMenu,
          trigger: (0, _preact.h)(_Menu.default, null)
        }, (0, _preact.h)("ul", {
          className: "header-navigation-items_hamburger-list"
        }, filteredItems.map(function (item) {
          return (0, _preact.h)(_MegaMenuLink.default, {
            key: (0, _utils.getUniqueKey)(item),
            item: item,
            parentProps: {
              communityCategoriesV2: communityCategoriesV2,
              knowledgeBaseCategoriesV2: knowledgeBaseCategoriesV2,
              openOnHover: false,
              isHamburgerList: true
            }
          });
        })))), (0, _preact.h)(_Logo.Logo, {
          src: (0, _absoluteUrlRuntime.resolveUrl)(logo),
          communityCustomerTitle: communityCustomerTitle,
          className: "is-hidden-L"
        })), isEntityEnabled('search') && isExtendableSearchVisible && (0, _preact.h)(_megaMenuSearch.default, {
          searchInfo: searchInfo,
          isUserGuest: !!user.id,
          extendSearch: extendSearch,
          enableFocusToSearch: enableFocusToSearch,
          enableExtendedSearch: function enableExtendedSearch() {
            return _this3.setState({
              extendSearch: true,
              enableFocusToSearch: true
            });
          },
          disableExtendedSearch: function disableExtendedSearch() {
            return _this3.setState({
              extendSearch: false,
              enableFocusToSearch: false
            });
          },
          searchRevamp: searchRevamp,
          aiSearchSummary: aiSearchSummary,
          isGuest: isGuest,
          aiSmartSearchEnableForAllRoles: aiSmartSearchEnableForAllRoles
        }))), (0, _preact.h)("section", {
          className: "main-navigation--nav-buttons-wrapper",
          "data-view": "MainNavigation"
        }, (0, _preact.h)("ul", null, showLanguageSelector && selectedLanguage && (0, _preact.h)("li", null, (0, _preact.h)(_CommunityLanguageSwitcher.default, {
          languages: languagesList,
          selectedLanguageCode: selectedLanguage,
          onLanguageChanged: function onLanguageChanged(languageCode) {
            return (0, _utils.onLanguageChanged)(languageCode);
          },
          enabledLanguages: enabledLanguages,
          publishedLanguages: publishedLanguages,
          userRoles: userRoles,
          allowedUserRoles: ALLOWED_ROLES
        })), isEntityEnabled('notification') && user !== null && user !== void 0 && user.id ? (0, _preact.h)("li", null, (0, _preact.h)(_NotificationCenter.default, null)) : null, _common.common.isModuleActive('theLoops') && _common.common.isModuleActive('theLoopsAIWidget') && _common.common.isModuleActive('autopilotNavbar') && (0, _preact.h)("li", null, (0, _preact.h)("div", {
          className: "autopilot-wrapper",
          "data-bounded-context": "Autopilot",
          "data-entity": "mega-menu"
        }, (0, _preact.h)(_phrase.default, {
          p: "autopilot.button.aria.label",
          renderAsText: true
        }, function (autopilotButtonLabel) {
          return (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)("/autopilot"),
            className: (0, _classnames.default)('btn', 'btn--secondary', 'autopilot-button'),
            "data-track-type": "click",
            "data-element-name": "Autopilot Button",
            "aria-label": autopilotButtonLabel
          }, (0, _preact.h)(_AiStarsV.default, {
            width: 18,
            height: 18
          }));
        }))), isEntityEnabled('topic') && !isTopicNew() && (0, _preact.h)("li", {
          className: "is-hidden-S"
        }, (0, _preact.h)(_phrase.default, {
          p: "main.navigation.add_topic",
          renderAsText: true
        }, function (title) {
          return (0, _preact.h)(_AddTopicAnchor.default, {
            title: title,
            newTopicURL: newTopicURL
          });
        })), isEntityEnabled('login') && (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "main.navigation.login",
          renderAsText: true
        }, function (loginPhrase) {
          if (user.id) {
            return (0, _preact.h)(_Dropdown.default, (0, _extends2.default)({}, user, {
              size: "M",
              embeddedLogoutUrl: _this3.props.embeddedLogoutUrl
            }));
          }

          return (0, _preact.h)("li", null, (0, _preact.h)(_LoginAnchor.default, {
            title: loginPhrase,
            ssoLoginUrl: ssoLoginUrl,
            showAuthPage: showAuthPage,
            embeddedLoginUrl: _this3.props.embeddedLoginUrl
          }));
        })))), isExtendableSearchVisible && (0, _preact.h)("div", {
          className: "header-navigation-search_mobile"
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('header-navigation_extendable-search', 'extended', 'is-visible-S')
        }, (0, _preact.h)("div", {
          className: "header-navigation_extended-search"
        }, (0, _preact.h)("form", {
          method: "get",
          action: (0, _absoluteUrlRuntime.resolveUrl)("/search/index")
        }, searchRevamp ? (0, _preact.h)("div", {
          className: "search-v2 no-icons-override-container"
        }, (0, _preact.h)(_SearchWidget.Search, (0, _extends2.default)({}, searchInfo, {
          enableFocusToSearch: enableFocusToSearch,
          callbackOnOutsideClick: _this3.callbackOutsideClickHandler,
          aiSearchSummary: aiSearchSummary,
          isGuest: isGuest,
          aiSmartSearchEnableForAllRoles: aiSmartSearchEnableForAllRoles
        }))) : (0, _preact.h)("div", null, (0, _preact.h)(_Search.default, (0, _extends2.default)({}, searchInfo, {
          isUserGuest: !!user.id,
          enableFocusToSearch: enableFocusToSearch,
          callbackOnOutsideClick: _this3.callbackOutsideClickHandler
        }))))))));
      });
    }
  }]);
  return HeaderNavigation;
}(_preact.Component);

var _default = (0, _ModuleEnablementContext.withModuleEnablement)(HeaderNavigation);

exports.default = _default;